/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListSpendRulesRequest,
  ListSpendRulesSecurity,
} from "../models/operations/listspendrules.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildSpendRulesListRulesQuery,
  prefetchSpendRulesListRules,
  queryKeySpendRulesListRules,
  SpendRulesListRulesQueryData,
} from "./spendRulesListRules.core.js";
export {
  buildSpendRulesListRulesQuery,
  prefetchSpendRulesListRules,
  queryKeySpendRulesListRules,
  type SpendRulesListRulesQueryData,
};

export type SpendRulesListRulesQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listSpendRules spendRules
 *
 * @remarks
 * List all budget rules for the current organization.
 */
export function useSpendRulesListRules(
  request?: ListSpendRulesRequest | undefined,
  security?: ListSpendRulesSecurity | undefined,
  options?: QueryHookOptions<
    SpendRulesListRulesQueryData,
    SpendRulesListRulesQueryError
  >,
): UseQueryResult<SpendRulesListRulesQueryData, SpendRulesListRulesQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildSpendRulesListRulesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listSpendRules spendRules
 *
 * @remarks
 * List all budget rules for the current organization.
 */
export function useSpendRulesListRulesSuspense(
  request?: ListSpendRulesRequest | undefined,
  security?: ListSpendRulesSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    SpendRulesListRulesQueryData,
    SpendRulesListRulesQueryError
  >,
): UseSuspenseQueryResult<
  SpendRulesListRulesQueryData,
  SpendRulesListRulesQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildSpendRulesListRulesQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setSpendRulesListRulesData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: SpendRulesListRulesQueryData,
): SpendRulesListRulesQueryData | undefined {
  const key = queryKeySpendRulesListRules(...queryKeyBase);

  return client.setQueryData<SpendRulesListRulesQueryData>(key, data);
}

export function invalidateSpendRulesListRules(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "rules", "list", ...queryKeyBase],
  });
}

export function invalidateAllSpendRulesListRules(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "rules", "list"],
  });
}
